debugInfoConfig.$inject = ['$compileProvider'];

// PRODUCTION global variable is defined in webpack config file
// debugInfo should be disabled in production
export default function debugInfoConfig($compileProvider) {
  // $compileProvider.debugInfoEnabled(!PRODUCTION)
}



// WEBPACK FOOTER //
// ./project/apps/factbox-app/factbox-app.debug.js